import { render, staticRenderFns } from "./OrganisationDetails.vue?vue&type=template&id=7a16ba77&scoped=true"
import script from "./OrganisationDetails.vue?vue&type=script&lang=js"
export * from "./OrganisationDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganisationDetails.vue?vue&type=style&index=0&id=7a16ba77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a16ba77",
  null
  
)

export default component.exports